// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:where(.vuetify-styles) .v-badge {
  display: inline-block;
  line-height: 1;
}

:where(.vuetify-styles) .v-badge__badge {
  align-items: center;
  display: inline-flex;
  border-radius: 10px;
  font-family: "Roboto", sans-serif;
  font-size: 0.75rem;
  font-weight: 500;
  height: 1.25rem;
  justify-content: center;
  min-width: 20px;
  padding: 4px 6px;
  pointer-events: auto;
  position: absolute;
  text-align: center;
  text-indent: 0;
  transition: 0.225s cubic-bezier(0.4, 0, 0.2, 1);
  white-space: nowrap;
}
:where(.vuetify-styles) .v-badge__badge {
  background: rgb(var(--v-theme-surface-variant));
  color: rgba(var(--v-theme-on-surface-variant), var(--v-high-emphasis-opacity));
}
:where(.vuetify-styles) .v-badge__badge:has(.v-icon) {
  padding: 4px 6px;
}
:where(.vuetify-styles) .v-badge--bordered .v-badge__badge::after {
  border-radius: inherit;
  border-style: solid;
  border-width: 2px;
  bottom: 0;
  color: rgb(var(--v-theme-background));
  content: "";
  left: 0;
  position: absolute;
  right: 0;
  top: 0;
  transform: scale(1.05);
}
:where(.vuetify-styles) .v-badge--dot .v-badge__badge {
  border-radius: 4.5px;
  height: 9px;
  min-width: 0;
  padding: 0;
  width: 9px;
}
:where(.vuetify-styles) .v-badge--dot .v-badge__badge::after {
  border-width: 1.5px;
}
:where(.vuetify-styles) .v-badge--inline .v-badge__badge {
  position: relative;
  vertical-align: middle;
}
:where(.vuetify-styles) .v-badge__badge .v-icon {
  color: inherit;
  font-size: 0.75rem;
  margin: 0 -2px;
}
:where(.vuetify-styles) .v-badge__badge img,
:where(.vuetify-styles) .v-badge__badge .v-img {
  height: 100%;
  width: 100%;
}

:where(.vuetify-styles) .v-badge__wrapper {
  display: flex;
  position: relative;
}
:where(.vuetify-styles) .v-badge--inline .v-badge__wrapper {
  align-items: center;
  display: inline-flex;
  justify-content: center;
  margin: 0 4px;
}

@media (forced-colors: active) {
  :where(.vuetify-styles) .v-badge__badge {
    forced-color-adjust: preserve-parent-color;
  }
  :where(.vuetify-styles) .v-badge__badge.v-badge__badge {
    background: highlight !important;
    color: highlighttext !important;
  }
}`, "",{"version":3,"sources":["webpack://./node_modules/vuetify/lib/components/VBadge/VBadge.css"],"names":[],"mappings":"AAAA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,mBAAmB;EACnB,iCAAiC;EACjC,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;EACd,+CAA+C;EAC/C,mBAAmB;AACrB;AACA;EACE,+CAA+C;EAC/C,8EAA8E;AAChF;AACA;EACE,gBAAgB;AAClB;AACA;EACE,sBAAsB;EACtB,mBAAmB;EACnB,iBAAiB;EACjB,SAAS;EACT,qCAAqC;EACrC,WAAW;EACX,OAAO;EACP,kBAAkB;EAClB,QAAQ;EACR,MAAM;EACN,sBAAsB;AACxB;AACA;EACE,oBAAoB;EACpB,WAAW;EACX,YAAY;EACZ,UAAU;EACV,UAAU;AACZ;AACA;EACE,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,sBAAsB;AACxB;AACA;EACE,cAAc;EACd,kBAAkB;EAClB,cAAc;AAChB;AACA;;EAEE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,aAAa;EACb,kBAAkB;AACpB;AACA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE;IACE,0CAA0C;EAC5C;EACA;IACE,gCAAgC;IAChC,+BAA+B;EACjC;AACF","sourcesContent":[".v-badge {\n  display: inline-block;\n  line-height: 1;\n}\n\n.v-badge__badge {\n  align-items: center;\n  display: inline-flex;\n  border-radius: 10px;\n  font-family: \"Roboto\", sans-serif;\n  font-size: 0.75rem;\n  font-weight: 500;\n  height: 1.25rem;\n  justify-content: center;\n  min-width: 20px;\n  padding: 4px 6px;\n  pointer-events: auto;\n  position: absolute;\n  text-align: center;\n  text-indent: 0;\n  transition: 0.225s cubic-bezier(0.4, 0, 0.2, 1);\n  white-space: nowrap;\n}\n.v-badge__badge {\n  background: rgb(var(--v-theme-surface-variant));\n  color: rgba(var(--v-theme-on-surface-variant), var(--v-high-emphasis-opacity));\n}\n.v-badge__badge:has(.v-icon) {\n  padding: 4px 6px;\n}\n.v-badge--bordered .v-badge__badge::after {\n  border-radius: inherit;\n  border-style: solid;\n  border-width: 2px;\n  bottom: 0;\n  color: rgb(var(--v-theme-background));\n  content: \"\";\n  left: 0;\n  position: absolute;\n  right: 0;\n  top: 0;\n  transform: scale(1.05);\n}\n.v-badge--dot .v-badge__badge {\n  border-radius: 4.5px;\n  height: 9px;\n  min-width: 0;\n  padding: 0;\n  width: 9px;\n}\n.v-badge--dot .v-badge__badge::after {\n  border-width: 1.5px;\n}\n.v-badge--inline .v-badge__badge {\n  position: relative;\n  vertical-align: middle;\n}\n.v-badge__badge .v-icon {\n  color: inherit;\n  font-size: 0.75rem;\n  margin: 0 -2px;\n}\n.v-badge__badge img,\n.v-badge__badge .v-img {\n  height: 100%;\n  width: 100%;\n}\n\n.v-badge__wrapper {\n  display: flex;\n  position: relative;\n}\n.v-badge--inline .v-badge__wrapper {\n  align-items: center;\n  display: inline-flex;\n  justify-content: center;\n  margin: 0 4px;\n}\n\n@media (forced-colors: active) {\n  .v-badge__badge {\n    forced-color-adjust: preserve-parent-color;\n  }\n  .v-badge__badge.v-badge__badge {\n    background: highlight !important;\n    color: highlighttext !important;\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
